<template>
    <v-container>
        <v-row><v-col cols="12"></v-col></v-row>
    </v-container>
</template>
<script>
    export default {
        name: "Spacer1"
    }
</script>

<style>

</style>
